import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import * as hooks from "lib/hooks"

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
	const isRouteAccessible = hooks.UseIsRouteAccessible()
	const navigate = useNavigate()
	useEffect(() => {
		isRouteAccessible.IfSome((isAccessible) => {
			if (!isAccessible) {
				navigate("/sector-admin-contact-info")
			}
		})
	}, [isRouteAccessible, navigate])
	return <>{children}</>
}
